const sampleJson = {
  Centre: 'testingclient3',
  WorkOrderID: '',
  LabNo: '3369506',
  NonSmartTestID: '',
  PanelID: 353106,
  PanelName: 'Freelance BANGALORE',
  PName: 'Mr AKSHAT SHARMA',
  Gender: 'M',
  Age: '23',
  ReferredBy: '',
  ReportURL:
    'https://lims.redcliffelabs.com/redcliffelabs/Design/Lab/getReport.aspx?LabNo=3369506&phead=1',
  ReturnURL:
    'http://localhost/redcliffelabs/Design/Lab/labreportnew.aspx?checkbal=0&phead=1',
  FilePath: '3369506',
  MaxID: 'RCL2683187',
  Date: 'Feb 22, 2023, 10:26 PM',
  hasPastData: false,
  results: [
    {
      Package_name: 'Complete Blood Count (CBC)',
      Package_book_code: 'H2023',
      Package_code: 'G03S01T09',
      investigation: [
        {
          test_name: 'Complete Blood Count (CBC)',
          test_book_code: 'H2023',
          test_code: 'G03S01T09',
          Type_id: '3854',
          observations: [
            {
              name: 'Hemoglobin',
              observation_time: '04-04-2023 11:04:06',
              id: '354',
              value: '14.5',
              MinValue: '11.5',
              MaxValue: '15.5',
              unit: 'g/dL',
              method: 'Non Cyanide - SLS',
              impression: '',
            },
            {
              name: 'Total Leucocyte Count (TLC / WBC)',
              observation_time: '04-04-2023 11:04:06',
              id: '355',
              value: '8.7',
              MinValue: '5.0',
              MaxValue: '13.0',
              unit: '10^3/uL',
              method: 'Flocytometry',
              impression: '',
            },
            {
              name: 'Erythrocyte Count (RBC)',
              observation_time: '04-04-2023 11:04:06',
              id: '358',
              value: '4.52',
              MinValue: '4.0',
              MaxValue: '5.2',
              unit: '10^6/uL',
              method: 'DC Detection',
              impression: '',
            },
            {
              name: 'Packed Cell Volume (PCV / HCT)',
              observation_time: '04-04-2023 11:04:06',
              id: '360',
              value: '43.5',
              MinValue: '35',
              MaxValue: '45',
              unit: '%',
              method: 'Cumulative Pulse Height Detection',
              impression: '',
            },
            {
              name: 'Mean Corpuscular Volume (MCV)',
              observation_time: '04-04-2023 11:04:06',
              id: '42',
              value: '85.3',
              MinValue: '77.0',
              MaxValue: '95.0',
              unit: 'fl',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Mean Corpuscular Hemoglobin (MCH)',
              observation_time: '04-04-2023 11:04:06',
              id: '43',
              value: '32.4',
              MinValue: '25.0',
              MaxValue: '33.0',
              unit: 'pg',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Mean Copuscular Hb Conc (MCHC)',
              observation_time: '04-04-2023 11:04:06',
              id: '45',
              value: '35.4',
              MinValue: '31.0',
              MaxValue: '37.0',
              unit: 'g/dL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Platelet count',
              observation_time: '04-04-2023 11:04:06',
              id: '362',
              value: '250',
              MinValue: '170',
              MaxValue: '450',
              unit: '10^3/uL',
              method: 'DC Detection',
              impression: '',
            },
            {
              name: 'RDW-SD',
              observation_time: '04-04-2023 11:04:06',
              id: '46',
              value: '41.3',
              MinValue: '35.1',
              MaxValue: '43.9',
              unit: 'fL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'RDW-CV',
              observation_time: '04-04-2023 11:04:06',
              id: '56',
              value: '12.5',
              MinValue: '11.6',
              MaxValue: '14.4',
              unit: '%',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'PDW',
              observation_time: '04-04-2023 11:04:06',
              id: '57',
              value: '14.3',
              MinValue: '10.0',
              MaxValue: '16.0',
              unit: '%',
              method: 'Electric Impedence',
              impression: '',
            },
            {
              name: 'Mean Platelet Volume (MPV)',
              observation_time: '04-04-2023 11:04:06',
              id: '831',
              value: '11.8',
              MinValue: '9.3',
              MaxValue: '12.1',
              unit: '%',
              method: 'Electric Impedence',
              impression: '',
            },
            {
              name: 'PCT',
              observation_time: '04-04-2023 11:04:06',
              id: '1',
              value: '0.21',
              MinValue: '0.17',
              MaxValue: '0.32',
              unit: '%',
              method: 'Electric Inpedence',
              impression: '',
            },
            {
              name: 'Neutrophils',
              observation_time: '04-04-2023 11:04:06',
              id: '833',
              value: '60',
              MinValue: '32',
              MaxValue: '62',
              unit: '%',
              method: 'Semiconductor Laser Flocytometry/ Light Microscopy',
              impression: '',
            },
            {
              name: 'Lymphocytes',
              observation_time: '04-04-2023 11:04:06',
              id: '832',
              value: '35',
              MinValue: '28',
              MaxValue: '48',
              unit: '%',
              method: 'Semiconductor Laser Flocytometry/ Light Microscopy',
              impression: '',
            },
            {
              name: 'Monocytes',
              observation_time: '04-04-2023 11:04:06',
              id: '41',
              value: '03',
              MinValue: '0',
              MaxValue: '4',
              unit: '%',
              method: 'Semiconductor Laser Flocytometry/ Light Microscopy',
              impression: '',
            },
            {
              name: 'Eosinophils',
              observation_time: '04-04-2023 11:04:06',
              id: '834',
              value: '02',
              MinValue: '0',
              MaxValue: '3',
              unit: '%',
              method: 'Semiconductor Laser Flocytometry/ Light Microscopy',
              impression: '',
            },
            {
              name: 'Basophils',
              observation_time: '04-04-2023 11:04:06',
              id: '835',
              value: '00',
              MinValue: '0',
              MaxValue: '1',
              unit: '%',
              method: 'Semiconductor Laser Flocytometry/ Light Microscopy',
              impression: '',
            },
            {
              name: 'Absolute Neutrophils',
              observation_time: '04-04-2023 11:04:06',
              id: '363',
              value: '5.22',
              MinValue: '2.00',
              MaxValue: '8.00',
              unit: '10^3/uL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Absolute Lymphocytes',
              observation_time: '04-04-2023 11:04:06',
              id: '365',
              value: '3.05',
              MinValue: '2.00',
              MaxValue: '8.00',
              unit: '10^3/uL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Absolute Monocytes',
              observation_time: '04-04-2023 11:04:06',
              id: '836',
              value: '0.26',
              MinValue: '0.20',
              MaxValue: '1.00',
              unit: '10^3/uL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Absolute Eosinophils',
              observation_time: '04-04-2023 11:04:06',
              id: '367',
              value: '0.17',
              MinValue: '0.02',
              MaxValue: '0.50',
              unit: '10^3/uL',
              method: 'Calculated',
              impression: '',
            },
            {
              name: 'Absolute Basophils',
              observation_time: '04-04-2023 11:04:06',
              id: '837',
              value: '0',
              MinValue: '0.02',
              MaxValue: '0.10',
              unit: '10^3/uL',
              method: 'Calculated',
              impression: 'Low',
            },
            {
              name: 'Mixed Cell',
              observation_time: '04-04-2023 11:04:06',
              id: '849',
              value: '0.00',
              MinValue: '0.0',
              MaxValue: '1.0',
              unit: '%',
              method: 'SLF / Light Microscopy',
              impression: '',
            },
          ],
        },
      ],
    },
    {
      Package_name: 'Thyroid Stimulating Hormone (TSH)',
      Package_book_code: 'C1168',
      Package_code: 'G07S11T05',
      investigation: [
        {
          test_name: 'Thyroid Stimulating Hormone (TSH)',
          test_book_code: 'C1168',
          test_code: 'G07S11T05',
          Type_id: '8718',
          observations: [
            {
              name: 'Thyroid Stimulating Hormone (TSH)',
              observation_time: '04-04-2023 11:04:19',
              id: '429',
              value: '2.35',
              MinValue: '0.38',
              MaxValue: '5.33',
              unit: 'uIU/mL',
              method: 'Chemiluminescent (CLIA)',
              impression: '',
            },
          ],
        },
      ],
    },
    {
      Package_name: 'Home Sample Collection (Phlebotomy Delhi NCR)',
      Package_book_code: 'HC016',
      Package_code: 'G02S01T01',
      investigation: [
        {
          test_name: 'Home Sample Collection (Phlebotomy Delhi NCR)',
          test_book_code: 'HC016',
          test_code: 'G02S01T01',
          Type_id: '9203',
          observations: [],
        },
      ],
    },
  ],
  headerPrefix: 'data:image/png;base64,',
  footerPrefix: 'data:image/png;base64,',
  headerMargin: '120px',
  footerMargin: '82px',
  headerBase64: '',
  footerBase64: '',
};
export default sampleJson;
